import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';
import { Award } from '@rma/public/awards/public/api-awards';
import { StaticImageUrlPipe } from '@rma/public/generic/util/environment';
import { ProfileAvatarComponent } from '@rma/public/profiles/public/ui-avatar-legacy';
import { StarRatingSummaryComponent } from '@rma/public/reviews/public/ui-rating';
import { MarketReportProfile } from '../domain';
import { MarketReportTopAwardComponent } from '../ui-market-report-top-award/market-report-top-award.component';

@Component({
  selector: 'rma-market-report-footer',
  templateUrl: './market-report-footer.component.html',
  styleUrls: ['./market-report-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProfileAvatarComponent,
    NgClass,
    StarRatingSummaryComponent,
    MarketReportTopAwardComponent,
    MatButtonModule,
    TranslocoPipe,
    StaticImageUrlPipe,
  ],
})
export class MarketReportFooterComponent {
  @Input()
  profile: MarketReportProfile | null | undefined;

  @Input()
  awards: Award[] | null | undefined;
}
